import { render, staticRenderFns } from "./PhoneTable.vue?vue&type=template&id=901866ba&scoped=true"
import script from "./PhoneTable.vue?vue&type=script&lang=js"
export * from "./PhoneTable.vue?vue&type=script&lang=js"
import style0 from "./PhoneTable.vue?vue&type=style&index=0&id=901866ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901866ba",
  null
  
)

export default component.exports